import { render, staticRenderFns } from "./providersDetail.vue?vue&type=template&id=0781e292&"
import script from "./providersDetail.vue?vue&type=script&lang=js&"
export * from "./providersDetail.vue?vue&type=script&lang=js&"
import style0 from "./providersDetail.vue?vue&type=style&index=0&id=0781e292&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports